// Import the useAuth hook directly from the AuthContext
export { useAuth } from '../context/AuthContext';
